import { render } from "./UserDeactivation.vue?vue&type=template&id=582c3f92&scoped=true"
import script from "./UserDeactivation.vue?vue&type=script&lang=js"
export * from "./UserDeactivation.vue?vue&type=script&lang=js"

import "./UserDeactivation.vue?vue&type=style&index=0&id=582c3f92&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-582c3f92"

export default script